import * as angular from "angular";
import {IController} from "angular";

export class siteAvatarCtrl implements IController {

  imageUrl: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.sites')
  .component('siteAvatar', {
    bindings: {
      imageUrl: '<'
    },
    template: require('./site-avatar.html').default,
    controller: siteAvatarCtrl
  });
